// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_BuscaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /config/traducoes/busca.
 *
 * `modo=padrao` matches the key itself (the pt-BR text in the code);
 * `modo=traducao` matches the text in `idioma`, which is then required —
 * "find me the key that renders THIS on the Spanish screen".
 */
import { registerContract } from './validate'

export interface Traducoes_BuscaInput {
q?: string
modo?: string
idioma?: string
pagina?: string
limite?: number
}

registerContract('Traducoes_BuscaInput', {
  q:      { type: 'string',  required: false },
  modo:   { type: 'string',  required: false },
  idioma: { type: 'string',  required: false },
  pagina: { type: 'string',  required: false },
  limite: { type: 'number',  required: false },
})
